<template>
  <div class="users">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
      <svg class="icon" aria-hidden="true">
        <use xlink:href="#icon-a-shezhi2"></use>
      </svg>
    </breadcrumbs>
  
    <div class="table-data">
      <div class="export">
      <artmisads-select-button class="add-new-id" @click="addNewTrackingId">Add New ID</artmisads-select-button>
    </div>
      <artmisads-table  rowKey="id"  v-model:pagination="pagination" :columns="columns" :data-source="data" :change="onTableChange"
        :loading="load" >
        <template #bodyCell="{ column, text, index, record }">
          <div v-if="column.key !== 'action' && column.key !== 'subTrackingIds' && column.key!=='link'">
            {{ text??'--' }}
          </div>
          <div v-if="column.key === 'link'">
            {{Number(record.brandLinkCount) +Number(record.productLinkCount) }}
          </div>
          <div v-if="column.key === 'action'">
            <!-- <a href="javascript:void(0)" @click="deleteTrackingId(record)" v-if="!record.children?.length">Delete</a> -->
            <a href="javascript:void(0)" @click="addSubTrackingId(record)" style="margin-left: 30px;" v-if="record.trackingIdType=='PRIMARY'">Add Sub ID</a>
          </div>
        </template>
      </artmisads-table>
    </div>
    <AddTrackingIdModal
      v-model:visible="showAddTrackingIdModal"
      :type="type"
      :primary="primary"
      :parentId="parentId"
      @save="handleSaveTrackingId"
    />
    <artmisads-modal title="warning" v-model:open="removeModel" @ok="onRemove"
      @cancel="() => {
        removeModel = false;
      }" style="width: 600px" okText="Confirm" cancelText="Cancel">
      <div class="deactive">
        Are you sure you want to delete this Tracking IDs?
      </div>
    </artmisads-modal>
  </div>
</template>

<script setup>
import { message } from "ant-design-vue";
import { ref, reactive, onMounted } from "vue";
import { trackingIdsApi } from "~/server/publisher/trackingIds";
import breadcrumbs from '../../../seller/breadcrumbs.vue';
import AddTrackingIdModal from './AddTrackingIdModal.vue';


const removeModel = ref(false);
const breadcrumbsData = {
  title: "Tracking IDs",
  des: "Manage your primary and sub tracking Ids",
  color: '#FFD358',
  links: [
  {
      name: "Home",
      path: "/operator/users",
    },
    {
      name: 'Settings',
      path: '/publisher/settings/profile',
    },
    {
      name: "Tracking IDs",
      path: "/publisher/settings/tracking-ids",
    },
  ],
};
const columns = [
  {
    title: "Primary ID",
    key: "trackingId",
    dataIndex: "trackingId",
    align:'center',
    width:250
  },
  {
    title: "Sub ID",
    dataIndex: "subTrackingId",
    key: "subTrackingId",
    align:'center',
    width:250
  },
  {
    title: "Links",
    dataIndex: "link",
    key: "link",
    align:'center',
    ellipsis:true,
    width:200
  },
 
  {
    key: "action", 
    title: "Action",
    align:'center'
  },
];

const deleteTrackingIdValue = ref('');
// let _data = [];
let load = ref(true);
const data = ref([]);
const pagination = reactive({
  current: 1,
  defaultPageSize: 10,
  size: 10,
  pageSize: 10,
  total: 0,
  pageSizeOptions: ['10', '20', '50', '100'],
  showSizeChanger: true,
});
const primary = ref('');
const parentId = ref('');
const onTableChange = ({ current, pageSize }) => {
  pagination.current = current;
  pagination.size = pageSize;
  pagination.pageSize = pageSize;
  init()
};
const type = ref('PRIMARY');
const init = () => {
  load.value = true;
  trackingIdsApi.getTrackingIds({ size:  pagination.pageSize,page:pagination.current }).then((res) => {
      data.value = res.data.data;
      data.value.forEach(v=>{
        if(v.subTrackingIds.length>0){
          v.children=v.subTrackingIds.map(v1=>{
          return {
            subTrackingId:v1.trackingId,
            trackingIdType:'SUB',
            productLinkCount:v1.productLinkCount,
            brandLinkCount:v1.brandLinkCount,
            id:v1.id,
          }
        })
        }
       delete v.subTrackingIds;
      })

      pagination.total = res.data.total;
      load.value = false;
  });
};

const showAddTrackingIdModal = ref(false);

const addNewTrackingId = () => {
  type.value = 'PRIMARY';
  showAddTrackingIdModal.value = true;
};

const handleSaveTrackingId = async ({ primary, sub,trackingIdType }) => {

    if(trackingIdType=='PRIMARY'){
      
      const {data,code}= await trackingIdsApi.addTrackingId({
      trackingId: primary,
      // trackingId: sub?sub:undefined,
      trackingIdType:trackingIdType
    });
    if(code==6111){
        message.error('Tracking ID already exists');
        return;
    }
    await trackingIdsApi.addTrackingId({
      trackingId: sub,
      parentId:data.id,
      trackingIdType:'SUB'
    });
    }
    else{
     const {code} = await trackingIdsApi.addTrackingId({
        trackingId: sub,
        parentId:primary,
        trackingIdType:'SUB'
      });
      if(code==6111){
        message.error('Tracking ID already exists');
        return;
      }
    }
    message.success('Tracking ID added successfully');
    showAddTrackingIdModal.value = false;
    init(); // 刷新表格
  
};

const deleteTrackingId = async (record) => {
  removeModel.value = true;
  deleteTrackingIdValue.value = record.id;
};
const onRemove=()=>{
  trackingIdsApi.deleteTrackingId(deleteTrackingIdValue.value).then((res)=>{
    if(res.success){
      removeModel.value = false;
      message.success('Tracking ID deleted successfully');
      init(); // 刷新表格
    }
  })
}
const addSubTrackingId = (record) => {
  // TODO: 实现添加子追踪ID的逻辑
  console.log('Add sub tracking ID for:', record);
  primary.value = record.trackingId;
  parentId.value = record.id;
  type.value = 'SUB';
  showAddTrackingIdModal.value = true;
};

onMounted(() => {
  init();
});
</script>

<style lang="less" scoped>
.add-new-id{
 background-color: var(--primary);
 color: #fff !important; 
 border-color: var(--primary) !important;
 &:hover{
  background-color: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
 }
}
.users {
  padding: 16px;
  padding-top: unset;
  width: 100%;
}

.filters {
  display: flex;
  justify-content: space-between;

  .search {
    display: flex;

    .option {
      >span {
        margin-right: 8px;
      }

      display: flex;
      align-items: center;
      margin-right: 24px;
    }
  }
}

.export {
  display: flex;
  justify-content: flex-end;
  margin: 16px 0;
}

.table-data {

  border-radius: 8px;
  border: 1px solid #fff;
  background-color: #fff;

    padding: 16px 16px 0;

    box-shadow: var(--section-box-shadow-6);
  :deep(.ant-table) {
    border-radius: 8px 8px 0 0;
  }

  :deep(.ant-table-cell) {
    padding-left: 8px;
    padding-right: 8px;

    >a {
      color: var(--primary);

      &:hover {
        color: var(--primary-hover);
      }
    }
  }

  :deep(.ant-table-thead) {
    border-radius: 8px 8px 0 0;
  }

  .user {
    flex: 1;

    .user-name {
      color: var(--dark-1);
      font-weight: 500;
      font-size: 16px;
      letter-spacing: 0.4px;
      line-height: 20px;

      >span {
        font-weight: 400;
        margin-left: 4px;
      }
    }

    .user-email {
      font-weight: 500;
      font-size: 12px;
      color: var(--dark-2);
      letter-spacing: 0.3px;
      line-height: 16px;
      padding: 10px 0;
    }

    .user-id {
      height: 16px;
      font-weight: 500;
      font-size: 12px;
      color: var(--dark-3);
      letter-spacing: 0.3px;
      line-height: 16px;
    }
  }

}

.show-url {
  word-break: break-all;
}

.pending-amount {
  color: var(--red-1);
}

.actions {
  gap: 8px;
  display: flex;
}


</style>
